export default "__VITE_ASSET__b_H_ZGY7__"